export const WIDGETS_CDN_URL = {
    internal: 'https://shared.fr.world.socgen/widgets/{widget}/v4/{widget}.js',
    external: 'https://shared.sgmarkets.com/widgets/{widget}/v4/{widget}.js',
    azure: 'https://sgwt-cdn-widgets.sgmarkets.com/widgets/{widget}/v4/{widget}.js',
    'internal-non-prod': 'https://shared-uat.fr.world.socgen/widgets/{widget}/v4/{widget}.js',
    'external-non-prod': 'https://shared-uat.sgmarkets.com/widgets/{widget}/v4/{widget}.js',
    'azure-non-prod': 'https://sgwt-widgets-dev.sgmarkets.com/widgets/{widget}/v4/{widget}.js',
};
export const propsBoolean = (prop) => (prop ? 'true' : undefined);
export const propsObject = (prop) => (prop ? JSON.stringify(prop) : undefined);
//# sourceMappingURL=utils.js.map